import { action } from 'easy-peasy';

import { IActionSetRelatedTeamMembers } from '../types';

const setRelatedTeamMembers: IActionSetRelatedTeamMembers = action((state, payload) => {
  state.relatedTeamMembers = payload;
});

export default setRelatedTeamMembers;
